import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { User } from "../models/user.model";

type State = {
    user?: User;
};

type Action = {
    setUser: (user?: User) => void;
};

const initialState: State = {
    user: undefined,
};

export const useUserStore = create(
    persist(
        devtools<State & Action>((set) => ({
            ...initialState,

            setUser: (value) =>
                set({
                    user: value,
                }),
        })),
        { name: "user-storage" }
    )
);
